import { createContext, useContext } from 'react';
var PageModelContext = createContext(null);
export var PageModelProvider = PageModelContext.Provider;
export function usePageModel() {
    var runtime = useContext(PageModelContext);
    if (!runtime) {
        throw new Error('usePageModel must be use under `PageModelProvider`');
    }
    return runtime;
}
